<lgb-header-gradient [height]="((!isSgining())? 180 : 100)" [background]="isSgining()"></lgb-header-gradient>
<div class="screen-container" [loading]="loading()">
	@if(!isSgining()){
		@if(userService.getImg()){
		  	<div class="huge-avatar w-50 rounded-full">
				<img [src]="img()" />
			</div>
		}
		@else{
			<div class="avatar avatar-placeholder">
			  <div class="huge-avatar bg-neutral text-neutral-content w-50 rounded-full">
			    	<span>AC</span>
			  </div>
			</div>
		}

		<p class="element-info mt-4">
			<i class="text-primary fa-sharp fa-light fa-circle-info"></i>
			Inscrit le {{user().dateCreate | date:'dd/MM/yyyy'}}
		</p>
		@if(!isAdmin()){
			<button (click)="unlog()" class="unlog btn btn-link">Déconnexion</button>
		}
	}
	@if(isAdmin()){
		<lgb-back [link]="router.get('admin-user-list')"></lgb-back>
	}
	@else{
		<lgb-back [link]="router.get(((isSgining())? 'login' : 'collect-home'))"></lgb-back>
	}
	@if(isSgining()){
		<h1 class="my-4">Inscription</h1>
	}
	@else{
		<!-- tabs -->
		<div class="my-4 tabs tabs-box">
			<a (click)="action.set('infos')" [ngClass]="{'tab-active': action()=='infos'}" class="tab">Mes infos</a>
			<a (click)="action.set('offre')" [ngClass]="{'tab-active': action()=='offre'}" class="tab">Mon offre</a>
		</div>
	}
	<div [ngClass]="{hidden: action()!='infos'}">
		<fieldset class="fieldset border-base-300 rounded-box border p-4 glass">
			<form #values #form="ngForm">
				<lgb-message [(msg)]="msg" [(error)]="error"></lgb-message>
				<!-- avatar -->
				<fieldset class="fieldset mb-2">
					<legend class="fieldset-legend">Avatar</legend>
					<input type="file" accept="image/*" class="file-input w-full" name="img"/>
					<label class="label">Max size 2MB</label>
				</fieldset>

				@if(!isSgining()){
					<label class="label mb-4">
						<input type="checkbox" name="rmImg" [(ngModel)]="user().rmImg" class="checkbox" />
						Supprimer mon avatar
					</label>
				}

				<!-- name -->
				<label class="floating-label mb-4">
				  <span>Prénom</span>
				  <input type="text" placeholder="Prénom" name="name" class="input input-md w-full" [(ngModel)]="user().name" required />
				</label>
				
				<!-- lastname -->
				<label class="floating-label mb-4">
				  <span>Nom</span>
				  <input type="text" placeholder="Nom" name="lastname" class="input input-md w-full" [(ngModel)]="user().lastname" required />
				</label>
				
				<!-- mail -->
				<label class="floating-label mb-4">
				  <span>E-mail</span>
				  <input type="mail" placeholder="mail@site.com" name="email" class="input input-md w-full" [(ngModel)]="user().email" required email/>
				</label>
				
				<!-- pass -->
				<label class="floating-label mb-4">
				  <span>Mot de passe</span>
				  <input type="password" placeholder="Mot de passe" name="pass" class="input input-md w-full" [(ngModel)]="user().pass" [required]="isSgining()"/>
				</label>
				
				<!-- birth -->
				<label class="floating-label mb-4">
				  <span>Date de naissance</span>
				  <input type="date" placeholder="Date de naissance" name="birth" class="input input-md w-full" [(ngModel)]="user().birth" required />
				</label>
				
				<!-- address -->
				<label class="floating-label mb-4">
				  <span>Adresse</span>
				  <input type="text" placeholder="Adresse" name="address" class="input input-md w-full" [(ngModel)]="user().address" required />
				</label>
				
				<!-- cp -->
				<label class="floating-label mb-4">
				  <span>Code postal</span>
				  <input type="text" placeholder="Code postal" name="cp" class="input input-md w-full" [(ngModel)]="user().cp" required />
				</label>
				
				<!-- ville -->
				<label class="floating-label mb-4">
				  <span>Ville</span>
				  <input type="text" placeholder="Ville" name="city" class="input input-md w-full" [(ngModel)]="user().city" required />
				</label>
				
				<!-- country -->
				<select class="select mb-4 w-full" name="country" [(ngModel)]="user().country" required>
				  <option [ngValue]="undefined" selected>Pays</option>
				  @for(p of pays(); track p.id){
					<option [value]="p.id">{{p.name}}</option>
				  }
				</select>


				@if(userService.hasRight('rights')){
					<div class="collapse collapse-plus bg-base-100 border-base-300 border mb-4">
					  <input type="checkbox" class="peer" />
					  <div class="collapse-title font-semibold">Droits utilisateur</div>
					  <div class="collapse-content text-sm">
					    @for(right of rights(); track right.name){
							<div class="cgv mb-2">
								<input 
									id="right-{{right.name}}"
									name="rights[]"
									value="{{right.name}}"
									type="checkbox"
									(change)="setRight(right.name)"
									[checked]="hasRight(right.name)"
									class="checkbox mr-2" 
								/>
								<label for="right-{{right.name}}">{{right.libelle}}</label>
							</div>
					    }
					  </div>
					</div>
				}

				<div class="cgv mb-2">
					<input id="form-newsletter" name="newsletter" [(ngModel)]="user().isNewsLetter" type="checkbox" class="checkbox checkbox-primary mr-2" />
					<label for="form-newsletter">
						Je veux être informé des nouvelles sorties, offres et exclusivités TCG !
					</label>
				</div>

				@if(isSgining()){
					<div class="cgv">
						<input id="cgv-link" name="cgv" [(ngModel)]="cgv" type="checkbox" class="checkbox checkbox-primary mr-2" required />
						<label for="cgv-link">
							En m'inscrivant j'accepte les conditions générales sans réserve qui sont ici : 
							<a href="#" class="text-primary" [routerLink]="router.get('cgv')">CGV</a> - 
							<a href="#" class="text-primary" [routerLink]="router.get('cgu')">CGU</a>
						</label>
					</div>
				}

				<div class="btn-container mt-4" >
					<button (click)="setUser(values)" class="btn btn-primary btn-gradient" [disabled]="form.invalid">Valider</button>
				</div>
			</form>
		</fieldset>
	</div>
	@if(!isSgining()){
		<div [ngClass]="{hidden: action()!='offre'}">
			<!-- licence lengend+ -->
			@if(actifPlan()){
				<fieldset class="element-show mb-4 text-base fieldset border-base-300 rounded-box border p-4 glass" [style.--i]="1">
					<div class="mb-2 badge badge-success">Actif</div>
					<h2>Legend <i class="text-primary fa-regular fa-plus"></i></h2>
					<p class="mt-2 text-xl font-bold">
						2,50€
						<span class="text-base font-normal text-base-content/60">/ mois</span> 
					</p>
					<p class="my-1 mb-2 text-xs opacity-60">
						Membre Legend+ depuis {{actifPlan().start | date:'dd/MM/yyyy'}}<br/>
						Prochain renouvellement : {{actifPlan().end | date:'dd/MM/yyyy'}}
					</p>
					<p class="mb-2 text-xs opacity-60">
						Merci de soutenir Legend-binder <i class="fa-solid fa-heart text-primary"></i>
					</p>
				</fieldset>

				<fieldset class="element-show mb-4 text-base fieldset border-base-300 rounded-box border p-4 glass" [style.--i]="1">
					<p class="my-1 mb-2 text-primary">
						Avantages actifs<br/>
					</p>
					<div>
						<div class="fonction-item">
							<!-- <i class="mr-2 fonction-icon text-primary fa-regular fa-rectangle-vertical-history"></i> -->
							<i class="text-primary mr-2 fa-solid fa-check"></i>
							Compatible avec tous les binders
						</div>
						<div class="fonction-item">
							<!-- <i class="mr-2 fonction-icon text-primary fa-regular fa-barcode-scan"></i> -->
							<i class="text-primary mr-2 fa-solid fa-check"></i>
							Scans illimités
						</div>
						<div class="fonction-item">
							<!-- <i class="mr-2 fonction-icon text-primary fa-regular fa-cart-shopping-fast"></i> -->
							<i class="text-primary mr-2 fa-solid fa-check"></i>
							Prix market place
						</div>
						<div class="fonction-item">
							<!-- <i class="mr-2 fonction-icon text-primary fa-regular fa-cards-blank"></i> -->
							<i class="text-primary mr-2 fa-solid fa-check"></i>
							Détection automatique des cartes
						</div>
						<div class="fonction-item">
							<!-- <i class="mr-2 fonction-icon text-primary fa-regular fa-piggy-bank"></i> -->
							<i class="text-primary mr-2 fa-solid fa-check"></i>
							Estimation automatique des prix
						</div>
						<div class="fonction-item">
							<!-- <i class="mr-2 fonction-icon text-primary fa-regular fa-paper-plane"></i> -->
							<i class="text-primary mr-2 fa-solid fa-check"></i>
							Partage simplifié
						</div>
					</div>
				</fieldset>
			}
			@else{
				<fieldset class="mb-4 text-base fieldset border-base-300 rounded-box border p-4 glass">
					<h1 class="header-offer element-show my-1 text-center" [style.--i]="0">
						<span class="brand">Legend</span>
						<i class="text-xl text-primary fa-regular fa-plus"></i>
					</h1>
					<p class="text-center opacity-60 mb-2">
						Passe au niveau légendaire
					</p>
					<p class="text-center">
						<span class="badge badge-ghost">
							<span class="opacity-60">Seulement</span> 2,50€ / mois
						</span>
					</p>
					<p class="my-1 mb-2 text-center text-primary">
						L’expérience complète, sans limite.
					</p>
					<div>
						<div class="fonction-item my-2">
							<i class="fonction-icon mr-2 text-primary fa-regular fa-rectangle-vertical-history"></i>
							Compatible avec tous les binders
						</div>
						<div class="fonction-item my-2">
							<i class="fonction-icon mr-2 text-primary fa-regular fa-barcode-scan"></i>
							Scans illimités
						</div>
						<div class="fonction-item my-2">
							<i class="fonction-icon mr-2 text-primary fa-regular fa-cart-shopping-fast"></i>
							Prix market place
						</div>
						<div class="fonction-item my-2">
							<i class="fonction-icon mr-2 text-primary fa-regular fa-cards-blank"></i>
							Détection automatique des cartes
						</div>
						<div class="fonction-item my-2">
							<i class="fonction-icon mr-2 text-primary fa-regular fa-piggy-bank"></i>
							Estimation automatique des prix
						</div>
						<div class="fonction-item my-2">
							<i class="fonction-icon mr-2 text-primary fa-regular fa-paper-plane"></i>
							Partage simplifié
						</div>
					</div>
					<span class="my-1 ml-1 text-xs opacity-60">Facturé annuellement, soit 29,90€</span>
					<button (click)="router.navigate('plan-checkout')" class="btn btn-primary btn-gradient my-3">Activer</button>
				</fieldset>
			}

		</div>
	}
</div>